import React, {ReactElement} from 'react';
import {Text} from 'components/Text';

export const NoMoneyLeft = (): ReactElement => (
  <Text data-test='no-more-money'>Больше денег нет</Text>
);
